import type { PropType } from 'vue';
import type { TTooltipProps } from './TTooltip.types';
import { useTooltip } from '@/composables/tooltip';
import { merge } from 'es-toolkit/compat';
import { computed, defineComponent } from 'vue';
import { useStyles } from './TTooltip.styles';

const defaultProps = {
  position: 'right',
  size: 'medium',
  trigger: 'hover',
};

export const TTooltip = defineComponent({
  name: 'TTooltip',
  props: {
    label: String as PropType<TTooltipProps['label']>,
    position: String as PropType<TTooltipProps['position']>,
    multilined: Boolean as PropType<TTooltipProps['multilined']>,
    size: String as PropType<TTooltipProps['size']>,
    trigger: String as PropType<TTooltipProps['trigger']>,
  },
  setup(_props, { slots, attrs }) {
    const props = computed(() => merge({}, defaultProps, _props, attrs));
    const trigger = computed(() => props.value.trigger);

    const { isVisible, wrapperRef, triggerHandler } = useTooltip(trigger);

    const baseClass = useStyles();
    const classes = computed(() => [
      baseClass.value,
      `${baseClass.value}--${props.value.position}`,
      `${baseClass.value}--${props.value.trigger}`,
      {
        [`${baseClass.value}--visible`]: isVisible.value,
        [`${baseClass.value}--multilined`]: props.value.multilined,
        [`${baseClass.value}--${props.value.size}`]: props.value.multilined,
      },
    ]);

    return () => (
      <div ref={wrapperRef} class={classes.value} {...triggerHandler.value}>
        {slots.default?.()}
        <div role="tooltip" class={`${baseClass.value}__tooltip`}>
          {slots.label?.() || props.value.label}
        </div>
      </div>
    );
  },
});
